import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchMedia, fetchSocialPostsThunk } from 'slices/influencer/thunk';
import { AppDispatch, RootState } from 'store';
import MediaGrid from './MediaGrid';
import { Post } from 'types/influencer';
import SocialMediaGrid from './SocialMediaGrid';
import { SocialPost } from 'types/campaign/collaborations';

interface InfluencerReelsProps {
    socialAccountId: string,
    onMediaClick: (post: SocialPost) => void,
    sort?: string
}


const InfluencerReels: React.FC<InfluencerReelsProps> = ({ socialAccountId, onMediaClick, sort='like_count' }) => {

    const dispatch: AppDispatch = useDispatch();

    const reelsData = useSelector((state: RootState) => state.influencers.social_media[socialAccountId]?.REELS);

    const reels = reelsData?.items ?? [];
    const page = reelsData?.page ?? 1;
    const has_more = reelsData?.has_more ?? true;

    const loading = useSelector((state: RootState) => state.influencers.mediaLoading);


    useEffect(() => {
        if (socialAccountId && sort)
            dispatch(fetchSocialPostsThunk({ page: 1, socialAccountId, type: 'REELS', sort }));
    }, [socialAccountId, sort])

    const nextPage = () => {
        if (has_more && socialAccountId) {
            const nextPageNumber = page + 1;
            dispatch(fetchSocialPostsThunk({ page: nextPageNumber, socialAccountId, type: 'REELS', sort }))
        }
    }

    return (
        <SocialMediaGrid onGridItemClick={onMediaClick} media={reels} onNextPage={nextPage} has_more={has_more} contentLoading={loading} />
    )
}

export default InfluencerReels